// extracted by mini-css-extract-plugin
export var orderSummary = "_t9-0";
export var showMoreLessButton = "_t9-1";